import { getBlobUrl } from '@theprintbar/shared';
import { createRef, useCallback, useEffect, useRef, useState } from 'react';

export function useDragAndDrop(setPreview?: (url: string) => void) {
	const dropRef = useRef<HTMLDivElement>(null);
	const inputRef = createRef<HTMLInputElement>();
	const [dragOver, setDragOver] = useState(false);

	const handleDragOver = useCallback((e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		setDragOver(true);
	}, []);

	const handleDrop = (e: React.DragEvent<HTMLDivElement>, current: HTMLInputElement) => {
		e.preventDefault();
		setDragOver(false);
		if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
			const file = e.dataTransfer.files[0];
			setPreview?.(getBlobUrl(file));
			if (current) {
				current.files = e.dataTransfer.files;
			}
		}
	};

	useEffect(() => {
		const dropArea = dropRef.current;
		if (dropArea && !!inputRef.current) {
			const current = inputRef.current;
			dropArea.addEventListener('dragover', e => handleDragOver(e as any));
			dropArea.addEventListener('drop', e => handleDrop(e as any, current));
			return () => {
				dropArea.removeEventListener('dragover', e => handleDragOver(e as any));
				dropArea.removeEventListener('drop', e => handleDrop(e as any, current));
			};
		}
	}, [inputRef, handleDragOver, handleDrop]);

	return {
		inputRef,
		dropRef,
		dragOver,
	};
}
